/**
 * Generic modal
 * @method setAlertModal
 */
export function ModalController() {
    //generic
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    //redeem
    this.confirmRedeemModal = null;
    this.serialModal = null;
    this.drawDeliveryModal = null;
    this.shippingAddressModal = null;

    //#region generic
    this.setAlertModal = function(alertModalController) {
        this.alertModal = alertModalController;
    };
    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };
    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };
    //#endregion generic


    //#region redeem
    this.setConfirmRedeemModal = function (confirmRedeemModalController) {
        this.confirmRedeemModal = confirmRedeemModalController;
    };
    this.setSerialModal = function (serialModalController) {
        this.serialModal = serialModalController;
    };
    this.setDrawDeliveryModal = function (drawDeliveryModalController) {
        this.drawDeliveryModal = drawDeliveryModalController;
    };
    this.setShippingAddressModal = function (shippingAddressModalController) {
        this.shippingAddressModal = shippingAddressModalController;
    };
    //#endregion redeem

}
